import { useMemo } from 'react';

import type { RhinoImageRatio } from '../image';

import { useImageSettings, ImageSize } from './useImageSettings';

export type UseLogoSettingsProps = {
  defaultImageRatio?: RhinoImageRatio;
  defaultLandscapeImageHeight?: number;
  defaultPortraitImageHeight?: number;
  imageSize?: ImageSize;
  referenceId: string;
};

export type LogoSettings = {
  imageHeight: number | undefined;
  imageRatio: RhinoImageRatio | undefined;
  imageType: number | undefined;
  imageWidth: number | undefined;
};

export function useLogoSettings({
  defaultImageRatio,
  defaultLandscapeImageHeight,
  defaultPortraitImageHeight,
  imageSize,
  referenceId,
}: UseLogoSettingsProps): LogoSettings | undefined {
  const imageSettings = useImageSettings({
    defaultImageRatio,
    defaultLandscapeImageHeight,
    defaultPortraitImageHeight,
    imageSize,
    referenceId,
  });

  return useMemo<LogoSettings | undefined>(() => {
    if (!imageSettings) {
      return undefined;
    }

    const { imageHeight, imageType, imageRatio, imageWidth } = imageSettings;

    return {
      imageHeight,
      imageRatio,
      imageType,
      imageWidth,
    };
  }, [imageSettings]);
}
